import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SupportContactService } from '../../../services/support-contact.service';
import { filter, Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-feedback-button',
  imports: [],
  templateUrl: './feedback-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './feedback-button.component.scss',
})
export class FeedbackButtonComponent implements OnInit, OnDestroy {
  public mailLink = '';

  private supportContactService = inject(SupportContactService);
  private router = inject(Router);

  private subscriptionSupportLink?: Subscription;
  private routerSubscription?: Subscription;

  public ngOnInit(): void {
    this.mailLink = this.supportContactService.fallbackMailUrl();
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.evaluateSupportMailLink();
      });
  }

  public ngOnDestroy(): void {
    if (this.subscriptionSupportLink) {
      this.subscriptionSupportLink.unsubscribe();
    }
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private evaluateSupportMailLink(): void {
    if (this.subscriptionSupportLink) {
      this.subscriptionSupportLink.unsubscribe();
    }
    this.subscriptionSupportLink = this.supportContactService.getSupportMailLink$().subscribe({
      next: (mailLink) => {
        this.mailLink = mailLink;
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
}
